import { Controller } from "@hotwired/stimulus";
import ToastService from "../../shared/toast_service";

// Turns one flash into one toast.
//
// The element is a CARRIER (`ApplicationComponent#
// render_flash`): an empty div whose only job is to
// deliver its text once. So the controller spends it the
// moment the toast is up and keeps no reference to act on
// later. It used to remove `this.element` from Toastify's
// callback, 5 seconds on, and a morph in between is free
// to hand that node to something else: the customer
// bundle's morphdom pairs unkeyed siblings by tag name,
// so the carrier became the checkout the next render drew
// in its place, and the timeout removed the page (CAL-522).
// A node this controller has not just looked at is not
// its carrier, whatever `this.element` still points to.
//
// Spending it at once also keeps the carrier out of the
// snapshot Turbo caches on the way out, so going back to
// the page does not toast the same flash a second time.
export default class extends Controller {
  static values = {
    text: String,
    type: String,
    duration: Number,
    gravity: String,
    position: String,
    multiple: Boolean,
    close: Boolean,
  };

  connect() {
    const text = this.textValue;
    this.element.remove();

    if (!text) {
      console.warn("Toast text is not set");
      return;
    }

    new ToastService().toast({
      text,
      duration: this.durationValue,
      gravity: this.gravityValue,
      position: this.positionValue,
      close: this.closeValue,
      type: this.typeValue,
      multiple: this.multipleValue,
    });
  }
}
